import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DayCard, Meal } from './DayCard';
// Meal Data
const mealPlanData: Record<number, Meal[]> = {
  1: [{
    type: 'Desayuno',
    description: 'Avena con chía + frutos rojos + nueces'
  }, {
    type: 'Comida',
    description: 'Salmón + ensalada grande + quinoa'
  }, {
    type: 'Cena',
    description: 'Sopa de lentejas con verduras'
  }, {
    type: 'Snack',
    description: 'Yogur natural o kéfir (si lo toleras) + canela'
  }],
  2: [{
    type: 'Desayuno',
    description: 'Huevos con espinaca + aguacate'
  }, {
    type: 'Comida',
    description: 'Pollo a la plancha + verduras asadas + arroz integral'
  }, {
    type: 'Cena',
    description: 'Ensalada de atún/sardinas + garbanzos + aceite de oliva'
  }, {
    type: 'Snack',
    description: 'Manzana + almendras'
  }],
  3: [{
    type: 'Desayuno',
    description: 'Smoothie verde (espinaca + limón + pepino) + proteína (yogur/kéfir o proteína vegetal)'
  }, {
    type: 'Comida',
    description: 'Tacos en hoja de lechuga con pavo + pico de gallo'
  }, {
    type: 'Cena',
    description: 'Tofu o pollo salteado con brócoli y jengibre'
  }, {
    type: 'Snack',
    description: 'Zanahoria + hummus'
  }],
  4: [{
    type: 'Desayuno',
    description: 'Yogur natural/kéfir + frutos rojos + linaza'
  }, {
    type: 'Comida',
    description: 'Ensalada "bowl" (quinoa + frijoles + verduras + aguacate)'
  }, {
    type: 'Cena',
    description: 'Crema de calabaza (sin crema) + ensalada'
  }, {
    type: 'Snack',
    description: 'Nueces'
  }],
  5: [{
    type: 'Desayuno',
    description: 'Omelette con champiñones + tomate'
  }, {
    type: 'Comida',
    description: 'Pescado blanco + camote + ensalada'
  }, {
    type: 'Cena',
    description: 'Garbanzos guisados con verduras y cúrcuma'
  }, {
    type: 'Snack',
    description: 'Cítrico (naranja/mandarina)'
  }],
  6: [{
    type: 'Desayuno',
    description: 'Avena nocturna con canela + chía'
  }, {
    type: 'Comida',
    description: 'Pavo/pollo + ensalada griega (aceitunas, pepino) + aceite de oliva'
  }, {
    type: 'Cena',
    description: 'Salteado de verduras + huevo o tofu'
  }, {
    type: 'Snack',
    description: 'Pepino con limón y sal'
  }],
  7: [{
    type: 'Desayuno',
    description: 'Pan integral 100% (si te cae bien) + aguacate + huevo'
  }, {
    type: 'Comida',
    description: 'Sopa de verduras + ensalada + proteína'
  }, {
    type: 'Cena',
    description: 'Salmón/sardinas + espárragos + quinoa'
  }, {
    type: 'Snack',
    description: 'Chocolate amargo (85%+) 1–2 cuadritos (opcional)'
  }]
};
export function MealPlan() {
  const [activeDay, setActiveDay] = useState(1);
  const days = [1, 2, 3, 4, 5, 6, 7];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white relative" data-id="element-100">
      <div className="max-w-6xl mx-auto" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-102">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-103">
            Tu Menú de 7 Días
          </h2>
          <p className="text-xl text-wellness-text/80 max-w-2xl mx-auto" data-id="element-104">
            Repite este menú en la semana 2 o intercambia comidas según tus
            preferencias.
          </p>
        </motion.div>

        {/* Day Selector */}
        <div className="mb-12 relative" data-id="element-105">
          <div className="flex overflow-x-auto hide-scrollbar pb-4 gap-3 justify-start lg:justify-center px-2" data-id="element-106">
            {days.map(day => {
            const isActive = activeDay === day;
            return <button key={day} onClick={() => setActiveDay(day)} className={`relative px-6 py-3 rounded-2xl font-medium text-lg whitespace-nowrap transition-colors duration-300 ${isActive ? 'text-white' : 'bg-wellness-sage/30 text-wellness-primary hover:bg-wellness-sage/60'}`} data-id="element-107">
                  {isActive && <motion.div layoutId="activeDayBg" className="absolute inset-0 bg-wellness-accent rounded-2xl -z-10" transition={{
                type: 'spring',
                bounce: 0.2,
                duration: 0.6
              }} data-id="element-108" />}
                  Día {day}
                </button>;
          })}
          </div>
        </div>

        {/* Meal Cards Container */}
        <div className="min-h-[600px] md:min-h-[400px]" data-id="element-109">
          <AnimatePresence mode="wait" data-id="element-110">
            <DayCard key={activeDay} dayNumber={activeDay} meals={mealPlanData[activeDay]} data-id="element-111" />
          </AnimatePresence>
        </div>
      </div>
    </section>;
}